import { render, staticRenderFns } from "./hospitalization.vue?vue&type=template&id=5319aaf7&scoped=true&"
import script from "./hospitalization.vue?vue&type=script&lang=js&"
export * from "./hospitalization.vue?vue&type=script&lang=js&"
import style0 from "./hospitalization.vue?vue&type=style&index=0&id=5319aaf7&prod&scoped=true&lang=less&"
import style1 from "./hospitalization.vue?vue&type=style&index=1&id=5319aaf7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5319aaf7",
  null
  
)

export default component.exports